import Lottie from "lottie-react";
import LottieFile from "../../assets/lotties/liquidity.json";
import MobileLottieFile from "../../assets/lotties/mobile-liquidity.json";
import { useMediaQuery } from "react-responsive";

const NewSlide3 = () => {
  const isMobile = useMediaQuery({ maxWidth: 640 });
  return (
    <div className=" min-h-screen snap-start w-full xl:flex flex-col items-center justify-center bg-gradient-to-b from-black to-[#111113]">
      <div className="text-center mb-16  scale-90 hidden xl:block">
        <h1 className="text-white text-4xl md:text-6xl font-normal font-stxihei pt-4 xl:pt-0">
          Dynamic <span className="text-main">Liquidity</span>, Multiple{" "}
          <span className="text-main">Markets</span>
        </h1>
      </div>

      <Lottie
        animationData={isMobile ? MobileLottieFile : LottieFile}
        className="h-full w-full object-cover scale-90 "
      />
    </div>
  );
};

export default NewSlide3;
